import { DebounceInput } from 'react-debounce-input';
import { SharedIcon } from '../../SharedIcon/SharedIcon';
import { MaterialSymbols } from 'material-design-icons-literal-types';

interface StylishNewSearchBarProps {
  className?: string;
  value?: string;
  onChangeSearchTerm: (searchTerm: string) => void;
  placeholder?: string;
  icon?: MaterialSymbols;
  label?: string;
  id?: string;
}

export const StylishNewSearchBar = ({
  className,
  value,
  onChangeSearchTerm,
  placeholder,
  icon,
  label,
  id,
}: StylishNewSearchBarProps) => {
  return (
    <div className={className}>
      {label && (
        <label className="form-label mb-2" htmlFor={id}>
          {label}
        </label>
      )}
      <div
        role="presentation"
        className="d-flex align-items-center gap-2 border border-neutral border-primary-active-hover border-primary-active-focus-within shadow-focused-focus-within position-relative rounded"
        style={{
          padding: '0.625rem 0.75rem',
          backgroundColor: 'inherit',
          transition:
            'border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out',
        }}
      >
        <SharedIcon iconName={icon || 'search'} />
        <DebounceInput
          id={id}
          value={value ?? ''}
          minLength={1}
          debounceTimeout={300}
          onChange={(e) => onChangeSearchTerm(e.target.value)}
          placeholder={placeholder || 'Search...'}
          className="form-control border-0 p-0 flex-fill bg-transparent"
        />
        {value && (
          <button
            type="button"
            className="btn p-0 border-0 bg-transparent"
            onClick={() => onChangeSearchTerm('')}
            aria-label="Clear search"
          >
            <SharedIcon iconName="close" size="sm" classes="text-weak" />
          </button>
        )}
      </div>
    </div>
  );
};
